import script from "./AlfaC2cCrossBorderPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AlfaC2cCrossBorderPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__